;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { CanaryClient } from '@qogita/deprecated-canary-client'
import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { getStocklistSourceQueryKey } from 'src/deprecated/utils/queryKey'

const getStocklistSource = ({
  sourceQid,
  canaryClient,
}: {
  sourceQid: string
  canaryClient: CanaryClient
}) => canaryClient.getStocklistSource(sourceQid)

const getStocklistSourceQueryOptions = ({
  sourceQid,
  canaryClient,
}: {
  sourceQid: string
  canaryClient: CanaryClient
}) =>
  // TODO: resolve this by moving to RSC or adding the missing dependency
  // oxlint-disable-next-line @tanstack/query/exhaustive-deps
  queryOptions({
    queryKey: getStocklistSourceQueryKey(sourceQid),
    queryFn: () => getStocklistSource({ sourceQid, canaryClient }),
  })

export const useGetStocklistSource = ({
  sourceQid,
  enabled,
}: {
  sourceQid: string | undefined
  enabled?: boolean
}) => {
  const canaryClient = useCanaryClient()

  return useQuery({
    ...getStocklistSourceQueryOptions({
      sourceQid: sourceQid ?? '',
      canaryClient,
    }),
    enabled: enabled && Boolean(sourceQid),
  })
}
